import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import BorderIcon from "../../assets/SVG/borderIcon";
import CalendarIcon from "../../assets/SVG/calendarIcon";
import ClockIcon from "../../assets/SVG/clockIcon";
import FemaleIcon from "../../assets/SVG/femaleIcon";
import FlagIcon from "../../assets/SVG/flagIcon";
import MaleIcon from "../../assets/SVG/maleIcon";
import StartAndStopIcon from "../../assets/SVG/startAndStopIcon";
import HistoryArea from "./historyArea";

export default function DashboardArea2({ data, dataArea }) {
  const arrNumber = [
    "یک",
    "دو",
    "سه",
    "چهار",
    "پنج",
    "شش",
    "هفت",
    "هشت",
    "نه",
    "ده",
    "یازده",
  ];
  const [openHistory, setOpenHistory] = useState();
  return (
    <Box mt="20px" display="flex" gap="10px">
      {!data[0]?.areas[0]?.city && (
        <HistoryArea
          dataArea={data}
          open={openHistory}
          setOpen={setOpenHistory}
        />
      )}
      {data && (
        <>
          <Box
            //   mt="50px"
            p="10px"
            bgcolor="#F5F9FF"
            borderRadius="12px"
            width="240px"
            height="200px"
            boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
          >
            <Box
              sx={{
                overflow: "auto",
                height: "100%",
                px: "5px",
                direction: "ltr",
                "::-webkit-scrollbar-thumb": {
                  background: "#126E83",
                  // borderRadius: "10px"
                },
                "::-webkit-scrollbar-track": {
                  background: "#A7C9D1",
                  borderRadius: "10px",
                },
              }}
            >
              <Box sx={{ direction: "rtl" }}>
                <Typography
                  fontWeight="bold"
                  color="var(--emr-font)"
                  fontSize={"20px"}
                  mt="15px"
                >
                  {"پروژه یک"}
                </Typography>
                <Box sx={{ cursor: "pointer" }} mt={"20px"} display={"flex"}>
                  <FlagIcon color={`var(--emr-${data[0].areas[0].color})`} />
                  <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                    {data[0].areas[0].name}
                  </Typography>
                </Box>
                {data[0].areas[0].startAt && (
                  <Box
                    sx={{ cursor: "pointer" }}
                    mt="10px"
                    gap="10px"
                    alignItems={"center"}
                    display={"flex"}
                  >
                    <CalendarIcon />
                    <Typography
                      color="var(--emr-gray)"
                      //   fontSize={"16px"}
                      // mt="10px"
                    >
                      {`${data[0].areas[0].startAt.split(" ", 2)[0]} - ${
                        data[0].areas[0].endAt.split(" ", 2)[0]
                      } `}
                    </Typography>
                  </Box>
                )}
                {/* {x.startAt && ( */}
                <Box
                  sx={{ cursor: "pointer" }}
                  mt="10px"
                  gap="10px"
                  alignItems={"center"}
                  display={"flex"}
                >
                  <ClockIcon />
                  <Typography
                    color="var(--emr-gray)"
                    //   fontSize={"16px"}
                    // mt="10px"
                  >
                    {data[0].areas[0].startAt.split(" ", 4)[2] +
                      " " +
                      "-" +
                      " " +
                      data[0].areas[0].endAt.split(" ", 4)[2]}
                  </Typography>
                </Box>
                {!data[0]?.areas[0]?.city && (
                  <Box
                    sx={{ cursor: "pointer" }}
                    mt="10px"
                    gap="10px"
                    alignItems={"center"}
                    display={"flex"}
                    onClick={() => setOpenHistory(true)}
                  >
                    <StartAndStopIcon />
                    <Typography
                      //   fontSize={"16px"}
                      // mt="10px"
                      color="var(--emr-darkblue)"
                    >
                      {"شروع/توقف/پایان اردو"}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          <Box
            // mr="10px"
            p="10px"
            bgcolor="#F5F9FF"
            borderRadius="12px"
            minWidth="250px"
            height="200px"
            boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
          >
            <Typography
              fontWeight="bold"
              color="var(--emr-font)"
              fontSize={"20px"}
              mt="15px"
            >
              {"مراجعین"}
            </Typography>

            <Box mt={"20px"} mr="10px" display={"flex"}>
              <BorderIcon />
              <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                {"کل"}
              </Typography>
            </Box>
            <Box
              fontSize="45px"
              mt="15px"
              textAlign="center"
              color="var(--emr-disable)"
            >
              {dataArea?.patients}
            </Box>
          </Box>
          <Box
            // mr="10px"
            p="10px"
            bgcolor="#F5F9FF"
            borderRadius="12px"
            minWidth="250px"
            height="200px"
            boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
          >
            <Typography
              fontWeight="bold"
              color="var(--emr-font)"
              fontSize={"20px"}
              mt="15px"
            >
              {"جهادگران"}
            </Typography>

            <Box mt={"20px"} mr="10px" display={"flex"}>
              <Box display="grid" width="50%">
                <Box display="flex" alignItems={"center"}>
                  <MaleIcon />
                  <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                    {"مردان"}
                  </Typography>
                </Box>
                <Box
                  fontSize="45px"
                  mt="15px"
                  textAlign="center"
                  color="var(--emr-disable)"
                >
                  {dataArea?.maleMembers}
                </Box>
              </Box>
              <Box display="grid">
                <Box display="flex" alignItems={"center"}>
                  <FemaleIcon />
                  <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                    {"زنان"}
                  </Typography>
                </Box>
                <Box
                  fontSize="45px"
                  mt="15px"
                  textAlign="center"
                  color="var(--emr-disable)"
                >
                  {dataArea?.femaleMembers}
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
